import { AuditApplicationArea, AuditServiceType } from 'types/graphql-global-types';
import Constants from '@utils/constants';

export const mapApplicationArea = (module: number): AuditApplicationArea =>
    module === Constants.Modules.RAM
        ? AuditApplicationArea.RISK_ASSESSMENT
        : module === Constants.Modules.SM
          ? AuditApplicationArea.SUBJECT_MONITORING
          : AuditApplicationArea.CENTRAL_MONITORING_2;

export const mapService = (module: number): AuditServiceType =>
    module === Constants.Modules.RAM
        ? AuditServiceType.CORE
        : module === Constants.Modules.SM
          ? AuditServiceType.SUBJECT_MONITORING
          : AuditServiceType.CENTRAL_MONITORING_2;
